import request from '@/router/axios';

export const add = (row) => {
  return request({
    url: '/api/produce/weidu-device-status-summary/insert',
    method: 'post',
    data: row
  })
}
export const update = (row) => {
  return request({
    url: '/api/produce/weidu-device-status-summary/update',
    method: 'post',
    data: row
  })
}
export const getDetail = (id) => {
  return request({
    url: '/api/produce/weidu-device-status-summary/selectId',
    method: 'get',
    params: {
      id
    }
  })
}
export const getList = (params) => {
  return request({
    url: '/api/produce/weidu-device-status-summary/selectPage',
    method: 'get',
    params
  })
}
export const remove = (ids) => {
  return request({
    url: '/api/produce/weidu-device-status-summary/deleteIds',
    method: 'get',
    params: {
      ids
    }
  })
}

